import { render, staticRenderFns } from "./IconReadIndicator.global.vue?vue&type=template&id=047bbe58&scoped=true&lang=pug&"
import script from "./IconReadIndicator.global.vue?vue&type=script&lang=ts&"
export * from "./IconReadIndicator.global.vue?vue&type=script&lang=ts&"
import style0 from "./IconReadIndicator.global.vue?vue&type=style&index=0&id=047bbe58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bbe58",
  null
  
)

export default component.exports